var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accepted-icon"},[_c('v-icon',{attrs:{"color":"white","size":"20"}},[_vm._v("mdi-check-circle-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }